/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFolderMinus(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M4 3.75A1.25 1.25 0 002.75 5v14A1.25 1.25 0 004 20.25h16A1.25 1.25 0 0021.25 19V8A1.25 1.25 0 0020 6.75h-9a.75.75 0 01-.624-.334L8.599 3.75H4zm-1.945-.695A2.75 2.75 0 014 2.25h5a.75.75 0 01.624.334l1.777 2.666H20A2.75 2.75 0 0122.75 8v11A2.75 2.75 0 0120 21.75H4A2.75 2.75 0 011.25 19V5c0-.73.29-1.429.805-1.945zM8.25 14a.75.75 0 01.75-.75h6a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75z'
      />
    </svg>
  );
}

export default SvgFolderMinus;
